import { MOCK_HELP_COLLECTIONS } from '../mock-data/index.js';
import { delay } from '../utils/helpers.js';

export class HelpService {
	constructor(baseAPI) {
		this.api = baseAPI;
	}

	async getHelpCollections(options = {}) {
		await this.api._ensureSession();

		if (this.api.mock) {
			await delay(200);
			return { status: true, data: MOCK_HELP_COLLECTIONS };
		}

		const endpoint = this.api._getEndpointWithParams(
			'/widget/help/collections',
			options
		);
		return this.api._makeRequest(endpoint, {
			method: 'GET',
			headers: { Authorization: `Bearer ${this.api.sessionToken}` },
		});
	}

	async searchHelpArticles(query, options = {}) {
		await this.api._ensureSession();

		if (this.api.mock) {
			await delay(200);
			const filtered = MOCK_HELP_COLLECTIONS.filter(
				(c) =>
					c.title.toLowerCase().includes(query.toLowerCase()) ||
					c.description.toLowerCase().includes(query.toLowerCase())
			);
			return { status: true, data: filtered };
		}

		const params = { q: query, ...options };
		const endpoint = this.api._getEndpointWithParams(
			'/widget/help/search',
			params
		);
		return this.api._makeRequest(endpoint, {
			method: 'GET',
			headers: { Authorization: `Bearer ${this.api.sessionToken}` },
		});
	}
}
